/* eslint-disable */
import React, {
  useState,
  type FC,
  Fragment,
  useRef,
  useEffect,
  useCallback,
} from 'react';
import {
  type IEmployerProps,
  type IAdminDetails,
  IAdminDetailsArray,
} from 'types/pages';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  FormGroup,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  IconButton,
  Typography,
  Box,
  CircularProgress,
  Checkbox,
  FormControlLabel,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import Grid from '@mui/material/Grid';
import Buttons from 'components/elements/Buttons';
import { debounce } from 'lodash';
import { strings } from 'i18n/Strings';
import {
  emailValidator,
  IBANBankNumberValidation,
  requiredValidator,
} from 'utils/validationUtils';
import {
  createOrganization,
  updateOrganizationService,
} from 'service/EmployerService';
import { setSnackBarFailed, setSnackBarSuccess } from 'store/snackBar';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import MuiPhoneNumber from 'material-ui-phone-number';
import Tooltip from '@mui/material/Tooltip';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import {
  addEmployerConstantTexts,
  pepTypeOptions,
  genderOptions,
  maritalStatusOptions,
  payrollFrequencyOptions,
} from 'constants/constantText';
import { FormHelperText } from '@mui/material';
import { BankAccountNumberLength } from 'utils/Constants';

const EditEmployer: FC<any> = ({
  setIsModalOpen,
  data,
  onClose,
  getupdateEmployerData,
}): JSX.Element => {
  const initialEmployerState: IEmployerProps = {
    companyName: data?.companyName,
    payrollFrequency: data?.payrollFrequency,
    regEmail: data?.regEmail,
    regPhoneNumber: data?.regPhoneNumber,
    regStreetOne: data.regStreetOne,
    regStreetTwo: data.regStreetTwo,
    regStreetThree: data.regStreetThree,
    regCity: data?.regCity,
    regState: data?.regState,
    regCountry: data?.regCountry,
    regPostalCode: data?.regPostalCode,
    employerTaxDetails: data?.employerTaxDetails,
    employerBankAccountName: data?.employerBankAccountName,
    employerBankAccountNumber: data?.employerBankAccountNumber,
    payrollDate: data?.payrollDate,
    createdByAcorn: data?.createdByAcorn ?? false,
    comments: data?.comments,
    tradingStreetOne: data?.tradingStreetOne,
    tradingStreetTwo: data?.tradingStreetTwo,
    tradingStreetThree: data?.tradingStreetThree,
    tradingCity: data?.tradingCity,
    tradingState: data?.tradingState,
    tradingCountry: data?.tradingCountry,
    tradingPostalCode: data?.tradingPostalCode,
    tradingPhoneNumber: data?.tradingPhoneNumber,
    tradingEmail: data?.tradingEmail,
    adminOption: data?.employee?.length > 0 ? 'Add now' : 'Later',
    adminDetails: data?.employee,
  };
  const { empId } = useSelector((state: RootState) => state.onboarding);
  const [toolTipAlert, setTooltipAlert] = useState(
    strings.displayText.deleteAlertMessage,
  );
  const { economicStatusAndOccupation } = useSelector(
    (state: RootState) => state.employeeDetails,
  );

  const handlePhoneChange = (value: string, fieldName: string): void => {
    if (fieldName === 'regPhoneNumber') {
      setFormData({ ...formData, [fieldName]: value });
    }
    if (fieldName === 'tradingPhoneNumber') {
      setFormData({ ...formData, [fieldName]: value });
    }
  };

  const dispatch = useDispatch();
  const [formData, setFormData] =
    useState<IEmployerProps>(initialEmployerState);
  const [formError, setFormError] = useState<IEmployerProps>({
    companyName: '',
    payrollFrequency: '',
    regEmail: '',
    regPhoneNumber: '',
    regCity: '',
    regCountry: '',
    regPostalCode: '',
    employerTaxDetails: '',
    employerBankAccountName: '',
    employerBankAccountNumber: '',
    payrollDate: '',
    comments: '',
    tradingCity: '',
    tradingCountry: '',
    tradingPostalCode: '',
    tradingPhoneNumber: '',
    tradingEmail: '',
    adminDetails: [],
  });
  const [openAdminDeleteInfo, setAdminDeleteInfo] = useState(false);
  const [loader, setLoader] = useState(false);

  const handleOpen = () => {
    setIsModalOpen(true);
  };

  const handleClose = () => {
    setIsModalOpen(false);
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    if (name === addEmployerConstantTexts.employerBankAccountNumber) {
      setFormData({ ...formData, [name]: value.toUpperCase() });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSwitchInputChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setFormData({ ...formData, [event.target.name]: event.target.checked });
  };

  const handleAdminInputValidation = (
    index: number,
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const { name, value } = event.target;
    const updatedAdmins = [
      ...(formError.adminDetails || []),
    ] as IAdminDetailsArray;

    // Initialize object at specified index if it doesn't exist
    if (!updatedAdmins[index]) {
      updatedAdmins[index] = {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
      };
    }

    switch (name) {
      case 'firstName': {
        if (requiredValidator(value)) {
          updatedAdmins[index].firstName = requiredValidator(value) || '';
          setFormError({ ...formError, adminDetails: updatedAdmins });
        } else {
          updatedAdmins[index].firstName = '';
          setFormError({ ...formError, adminDetails: updatedAdmins });
        }
        break;
      }
      case 'lastName': {
        if (requiredValidator(value)) {
          updatedAdmins[index].lastName = requiredValidator(value) || '';
          setFormError({ ...formError, adminDetails: updatedAdmins });
        } else {
          updatedAdmins[index].lastName = '';
          setFormError({ ...formError, adminDetails: updatedAdmins });
        }
        break;
      }
      case 'email': {
        if (emailValidator(value)) {
          updatedAdmins[index].email = emailValidator(value) || '';
          setFormError({ ...formError, adminDetails: updatedAdmins });
        } else {
          updatedAdmins[index].email = '';
          setFormError({ ...formError, adminDetails: updatedAdmins });
        }
        break;
      }
      case 'phone': {
        // Normalize to avoid double + (e.g. ++353 -> +353)
        const normalizedPhone =
          typeof value === 'string' ? value.replace(/^\+\+/, '+') : value;
        if (requiredValidator(normalizedPhone)) {
          updatedAdmins[index].phone = requiredValidator(normalizedPhone) || '';
          setFormError({ ...formError, adminDetails: updatedAdmins });
        } else {
          updatedAdmins[index].phone = '';
          setFormError({ ...formError, adminDetails: updatedAdmins });
        }
        break;
      }
      default:
        break;
    }
  };

  const handleValidation = (e: {
    target: {
      name: string;
      value: string;
    };
  }): void => {
    const { name, value } = e.target;
    if (name === 'regEmail') {
      const regEmailError = emailValidator(value) ? emailValidator(value) : '';
      setFormError({ ...formError, regEmail: regEmailError });
    } else if (name === addEmployerConstantTexts.employerBankAccountNumber) {
      const requiredError = requiredValidator(value);
      const validationError = IBANBankNumberValidation(value);
      if (requiredError) {
        setFormError({ ...formError, [name]: requiredError });
      } else if (validationError) {
        setFormError({ ...formError, [name]: IBANBankNumberValidation(value) });
      } else {
        setFormError({ ...formError, [name]: '' });
      }
    } else if (name === addEmployerConstantTexts.payrollDate) {
      const fieldError = requiredValidator(value);
      setFormError({ ...formError, payrollDate: fieldError });
    } else {
      const fieldError = requiredValidator(value)
        ? requiredValidator(value)
        : '';
      setFormError({ ...formError, [name]: fieldError });
    }
  };

  const handleAdminDetailsChange = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    if (event.target.value === 'Add now') {
      setFormData({
        ...formData,
        adminOption: event.target.value,
        adminDetails: [{ firstName: '', lastName: '', email: '', phone: '' }],
      });
    } else {
      setFormData({
        ...formData,
        adminOption: event.target.value,
      });
    }
  };

  const handleAdminInputChange = (
    index: number,
    event?: React.ChangeEvent<HTMLInputElement>,
    objValue?: string,
    objKey?: string,
  ) => {
    let updateAdmins = [...(formData.adminDetails || [])] as IAdminDetailsArray;

    if (event?.target) {
      const { name, value } = event.target;

      updateAdmins[index][name as keyof IAdminDetails] = value;
    }

    if (objKey && objValue !== undefined) {
      updateAdmins[index][objKey as keyof IAdminDetails] = objValue;
    }

    setFormData({
      ...formData,
      adminDetails: updateAdmins,
    });
  };

  const handleAddAdmin = () => {
    const updatedAdmins = formData.adminDetails || [];
    setFormData({
      ...formData,
      adminDetails: [
        ...updatedAdmins,
        { firstName: '', lastName: '', email: '', phone: '' },
      ],
    });
  };

  const handleRemoveAdmin = (index: number) => {
    const updatedAdmins = [...formData.adminDetails];
    updatedAdmins.splice(index, 1);
    setFormData({ ...formData, adminDetails: updatedAdmins });
    setTooltipAlert(strings.displayText.addAnotherAdminText);
  };

  const handleFormValidate = (data: IEmployerProps) => {
    let errors: any = {};

    if (!data.companyName) {
      errors.companyName = strings.displayText.fillCompanyName;
    }

    if (!data.payrollFrequency) {
      errors.payrollFrequency = strings.displayText.fillPayrollFrequency;
    }

    if (!data.regEmail) {
      errors.regEmail = strings.displayText.fillRegEmail;
    }

    if (!data.regPhoneNumber) {
      errors.regPhoneNumber = strings.displayText.fillRegPhone;
    }

    if (!data.regCountry) {
      errors.regCountry = strings.displayText.fillCountry;
    }

    if (!data.regPostalCode) {
      errors.regPostalCode = strings.displayText.fillPostalCode;
    }

    if (!data.employerTaxDetails) {
      errors.employerTaxDetails = strings.displayText.fillEmployerTaxDetails;
    }

    if (!data.employerBankAccountName) {
      errors.employerBankAccountName =
        strings.displayText.fillEmployerBankAccountName;
    }

    if (!data.employerBankAccountNumber) {
      errors.employerBankAccountNumber =
        strings.displayText.fillEmployerBankAccountNumber;
    }
    console.log(
      'adad',
      IBANBankNumberValidation(data.employerBankAccountNumber as string),
    );
    if (
      data.employerBankAccountNumber &&
      IBANBankNumberValidation(data.employerBankAccountNumber)
    ) {
      console.log('in error');
      errors.employerBankAccountNumber =
        strings.displayText.employerBankAccountNumberFormatCheck;
    }
    if (!data.payrollDate) {
      errors.payrollDate = strings.displayText.fillPayrollDate;
    }
    if (!data.tradingEmail) {
      errors.tradingEmail = strings.displayText.fillTradingEmail;
    }

    if (!data.tradingCountry) {
      errors.tradingCountry = strings.displayText.fillCountry;
    }

    if (!data.tradingPostalCode) {
      errors.tradingPostalCode = strings.displayText.fillPostalCode;
    }
    if (!data.tradingPhoneNumber) {
      errors.tradingPhoneNumber = strings.displayText.fillTradingPhone;
    }

    if (data.adminDetails.length > 0) {
      data.adminDetails.forEach((admin, index) => {
        if (!admin.firstName) {
          errors[`adminDetails[${index}].firstName`] =
            strings.displayText.fillMandatoryFields;
        }
        if (!admin.lastName) {
          errors[`adminDetails[${index}].lastName`] =
            strings.displayText.fillMandatoryFields;
        }
        if (!admin.email || emailValidator(admin.email)) {
          errors[`adminDetails[${index}].email`] =
            strings.displayText.fillMandatoryFields;
        }
        if (!admin.gender) {
          errors[`adminDetails[${index}].gender`] =
            strings.displayText.fillMandatoryFields;
        }
        if (!admin.maritalStatus) {
          errors[`adminDetails[${index}].maritalStatus`] =
            strings.displayText.fillMandatoryFields;
        }
        if (!admin.economicStatus) {
          errors[`adminDetails[${index}].economicStatus`] =
            strings.displayText.fillMandatoryFields;
        }
        // if id is 12 its not economically active so dont include it
        const hasEconomicStatus =
          admin.economicStatus && admin.economicStatus !== 12;
        const isOccupationMissing =
          admin.economicOccupation === 0 ||
          admin.economicOccupation === undefined;
        if (hasEconomicStatus && isOccupationMissing) {
          errors[`adminDetails[${index}].economicOccupation`] =
            strings.displayText.fillMandatoryFields;
        }
        if (admin.pepType === undefined || admin.pepType === null) {
          errors[`adminDetails[${index}].pepType`] =
            strings.displayText.fillMandatoryFields;
        }
      });
    }
    return Object.keys(errors).length === 0;
  };

  const handleSaveEmployer = () => {
    if (handleFormValidate(formData)) {
      // save employer to database or API
      const dataOfForm = {
        ...formData,
        adminDetails: formData?.adminDetails?.map((admin) => ({
          ...admin,
          phone:
            typeof admin.phone === 'string'
              ? admin.phone.replace(/^\+\+/, '+')
              : admin.phone,
          economicStatus:
            economicStatusAndOccupation?.categories?.find(
              (category) => category.id === admin.economicStatus,
            )?.subCategories?.length > 0
              ? admin.economicOccupation
              : admin.economicStatus,
        })),
        empId,
      };
      setLoader(true);
      updateOrganizationService(data.organizationId, dataOfForm)
        .then((res: any) => {
          getupdateEmployerData();
          // reset form data
          setFormData({
            companyName: '',
            payrollFrequency: '',
            regEmail: '',
            regPhoneNumber: '',

            regCity: '',
            regState: '',
            regCountry: '',
            regPostalCode: '',
            employerTaxDetails: '',
            employerBankAccountName: '',
            payrollDate: '',
            createdByAcorn: false,
            comments: '',
            tradingCity: '',
            tradingState: '',
            tradingCountry: '',
            tradingPostalCode: '',
            tradingEmail: '',
            tradingPhoneNumber: '',
            adminDetails: [],
          });
          setLoader(false);
          onClose(false);
          dispatch(
            setSnackBarSuccess({
              snackBarMessage: strings.displayText.employerUpdatedSuccessText,
            }),
          );
        })
        .catch((err) => {
          setLoader(false);
          dispatch(
            setSnackBarFailed({ snackBarMessage: err?.response?.data?.msg }),
          );
        });
    } else {
      if (formError.employerBankAccountNumber) {
        dispatch(
          setSnackBarFailed({
            snackBarMessage:
              strings.displayText.employerBankAccountNumberFormatCheck,
          }),
        );
      } else {
        dispatch(
          setSnackBarFailed({
            snackBarMessage: strings.displayText.fillMandatoryFields,
          }),
        );
      }
    }
  };
  const employerInputField = [
    {
      label: strings.displayText.companyNameLabel,
      name: addEmployerConstantTexts.companyName,
      value: formData.companyName,
      helperText: formError?.companyName,
      type: 'text',
    },
    {
      label: strings.displayText.payrollFrequencyLabel,
      name: addEmployerConstantTexts.payrollFrequency,
      value: formData.payrollFrequency,
      helperText: formError?.payrollFrequency,
      type: 'text',
    },
    {
      label: strings.displayText.registerEmailLabel,
      name: addEmployerConstantTexts.regEmail,
      value: formData.regEmail,
      helperText: formError?.regEmail,
      type: 'email',
    },
    {
      label: strings.displayText.registerPhoneNoLabelWithoutStart,
      name: addEmployerConstantTexts.regPhoneNumber,
      value: formData.regPhoneNumber,
      helperText: formError?.regPhoneNumber,
    },

    {
      label: strings.displayText.registerStreetOneLabel,
      name: addEmployerConstantTexts.regStreetOne,
      value: formData.regStreetOne,
      type: 'text',
      isRequired: false,
    },
    {
      label: strings.displayText.registerStreetTwoLabel,
      name: addEmployerConstantTexts.regStreetTwo,
      value: formData.regStreetTwo,
      type: 'text',
      isRequired: false,
    },
    {
      label: strings.displayText.registerStreetThreeLabel,
      name: addEmployerConstantTexts.regStreetThree,
      value: formData.regStreetThree,
      type: 'text',
      isRequired: false,
    },
    {
      label: strings.displayText.registerCityLabel,
      name: addEmployerConstantTexts.regCity,
      value: formData.regCity,
      type: 'text',
      isRequired: false,
    },
    {
      label: strings.displayText.registerStateLabel,
      name: addEmployerConstantTexts.regState,
      value: formData.regState,
      isRequired: false,
    },
    {
      label: strings.displayText.registerCountryLabel,
      name: addEmployerConstantTexts.regCountry,
      value: formData.regCountry,
      helperText: formError?.regCountry,
      type: 'text',
    },
    {
      label: strings.displayText.registerEircodeLabel,
      name: addEmployerConstantTexts.regPostalCode,
      value: formData.regPostalCode,
      helperText: formError?.regPostalCode,
      type: 'text',
    },
    {
      label: strings.displayText.employerTaxDetails,
      name: addEmployerConstantTexts.employerTaxDetails,
      value: formData.employerTaxDetails,
      helperText: formError?.employerTaxDetails,
      type: 'text',
    },
    {
      label: strings.displayText.employerBankAccountName,
      name: addEmployerConstantTexts.employerBankAccountName,
      value: formData.employerBankAccountName,
      helperText: formError?.employerBankAccountName,
      type: 'text',
    },
    {
      label: strings.displayText.employerBankAccountNumber,
      name: addEmployerConstantTexts.employerBankAccountNumber,
      value: formData.employerBankAccountNumber,
      helperText: formError?.employerBankAccountNumber,
      type: 'text',
    },
    {
      label: strings.displayText.payrollDate,
      name: addEmployerConstantTexts.payrollDate,
      value: formData.payrollDate,
      helperText: formError?.payrollDate,
      type: 'text',
    },
    {
      label: strings.displayText.comments,
      name: addEmployerConstantTexts.comments,
      value: formData.comments,
      type: 'text',
    },
    {
      label: strings.displayText.tradingEmailLabel,
      name: addEmployerConstantTexts.tradingEmail,
      value: formData.tradingEmail,
      helperText: formError?.tradingEmail,
      type: 'email',
    },
    {
      label: strings.displayText.tradingPhoneNoLabelWithoutStar,
      name: addEmployerConstantTexts.tradingPhoneNumber,
      value: formData.tradingPhoneNumber,
      helperText: formError?.tradingPhoneNumber,
    },

    {
      label: strings.displayText.tradingStreetOneLabel,
      name: addEmployerConstantTexts.tradingStreetOne,
      value: formData.tradingStreetOne,
      type: 'text',
      isRequired: false,
    },
    {
      label: strings.displayText.tradingStreetTwoLabel,
      name: addEmployerConstantTexts.tradingStreetTwo,
      value: formData.tradingStreetTwo,
      type: 'text',
      isRequired: false,
    },
    {
      label: strings.displayText.tradingStreetThreeLabel,
      name: addEmployerConstantTexts.tradingStreetThree,
      value: formData.tradingStreetThree,
      type: 'text',
      isRequired: false,
    },
    {
      label: strings.displayText.tradingcityLabel,
      name: addEmployerConstantTexts.tradingCity,
      value: formData.tradingCity,
      type: 'text',
      isRequired: false,
    },
    {
      label: strings.displayText.tradingStateLabel,
      name: addEmployerConstantTexts.tradingState,
      value: formData.tradingState,
      type: 'text',
      isRequired: false,
    },
    {
      label: strings.displayText.tradingCountryLabel,
      name: addEmployerConstantTexts.tradingCountry,
      value: formData.tradingCountry,
      helperText: formError?.tradingCountry,
      type: 'text',
    },
    {
      label: strings.displayText.tradingEircodeLabel,
      name: addEmployerConstantTexts.tradingPostalCode,
      value: formData.tradingPostalCode,
      helperText: formError?.tradingPostalCode,
      type: 'text',
    },
  ];

  return (
    <Fragment>
      <Box sx={{ maxWidth: '50rem' }}>
        <Box component="form" noValidate autoComplete="off">
          <Grid container spacing={2}>
            {employerInputField?.map((element, index) => (
              <Grid
                item
                xs={element.name === addEmployerConstantTexts.comments ? 12 : 6}
                key={index}
              >
                {element.name === 'regPhoneNumber' ||
                element.name === 'tradingPhoneNumber' ? (
                  <MuiPhoneNumber
                    enableLongNumbers={true}
                    required={true}
                    label={element.label}
                    name={element.name}
                    defaultCountry={'ie'}
                    variant="outlined"
                    fullWidth
                    onChange={(value: string) =>
                      handlePhoneChange(value, element.name)
                    }
                    value={element.value}
                    helperText={element.helperText}
                    sx={{
                      '& p': {
                        color: 'red',
                      },
                      my: 2,
                    }}
                  />
                ) : element.name ===
                  addEmployerConstantTexts.payrollFrequency ? (
                  <Grid mt={2} item xs={6} key={index}>
                    <FormControl
                      fullWidth
                      sx={{
                        '& p': {
                          color: 'red',
                        },
                      }}
                    >
                      <InputLabel>
                        {strings.displayText.payrollFrequencyLabel}
                      </InputLabel>
                      <Select
                        label={element.label}
                        name={addEmployerConstantTexts.payrollFrequency}
                        required={true}
                        value={formData.payrollFrequency}
                        onChange={handleInputChange}
                        style={{ width: '392px' }}
                      >
                        {payrollFrequencyOptions.map((option) => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </Select>
                      <FormHelperText>{element.helperText}</FormHelperText>
                    </FormControl>
                  </Grid>
                ) : element.name === addEmployerConstantTexts.comments ? (
                  <TextField
                    margin="dense"
                    fullWidth
                    label={element.label}
                    name={element.name}
                    onChange={handleInputChange}
                    value={element.value}
                    multiline
                    minRows={3}
                  />
                ) : element.name === addEmployerConstantTexts.payrollDate ? (
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'flex-start',
                      width: '100%',
                    }}
                  >
                    <TextField
                      margin="normal"
                      required={Boolean(element.isRequired)}
                      fullWidth
                      label={element.label}
                      name={element.name}
                      onChange={handleInputChange}
                      onBlur={handleValidation}
                      value={element.value}
                      sx={{
                        width: '100%',
                        '& p': {
                          color: 'red',
                        },
                        mb: 2,
                      }}
                      type={element.type}
                      helperText={element.helperText}
                    />
                    <FormControlLabel
                      sx={{ mt: 0.5, ml: 0, mr: 0 }}
                      control={
                        <Checkbox
                          color="success"
                          name="createdByAcorn"
                          checked={Boolean(formData.createdByAcorn)}
                          onChange={handleSwitchInputChange}
                        />
                      }
                      label={strings.displayText.registerCreatedByAcornLabel}
                    />
                  </Box>
                ) : (
                  <TextField
                    // inputRef={inputRef}
                    margin="normal"
                    required={Boolean(element.isRequired)}
                    fullWidth
                    label={element.label}
                    name={element.name}
                    onChange={handleInputChange}
                    onBlur={handleValidation}
                    value={element.value}
                    sx={{
                      '& p': {
                        color: 'red',
                      },
                      mb: 2,
                    }}
                    type={element.type}
                    // error={element.error}
                    helperText={element.helperText}
                    inputProps={
                      element.name === addEmployerConstantTexts.regPostalCode ||
                      element.name ===
                        addEmployerConstantTexts.tradingPostalCode
                        ? { maxLength: 8 }
                        : element.name ===
                          addEmployerConstantTexts.employerBankAccountNumber
                        ? { maxLength: BankAccountNumberLength }
                        : {}
                    }
                  />
                )}
              </Grid>
            ))}

            <Grid item xs={6} my={2}>
              <FormControl fullWidth>
                <InputLabel id="admin-detail-select-label">
                  Admin details
                </InputLabel>
                <Select
                  labelId="admin-detail-select-label"
                  margin="normal"
                  value={formData.adminOption}
                  onChange={handleAdminDetailsChange}
                  label="Admin Details"
                >
                  <MenuItem value="Add now">Add now</MenuItem>
                  <MenuItem value="Later">Later</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            {formData.adminOption === 'Add now' && (
              <>
                {formData.adminDetails.map(
                  (admin: IAdminDetails, index: number) => (
                    <Grid item xs={12}>
                      <Box key={index} mt={2}>
                        {data?.employee?.length > 0 &&
                        formData?.adminDetails?.length === 1 ? (
                          <ClickAwayListener
                            onClickAway={() => setAdminDeleteInfo(false)}
                          >
                            <div>
                              <Tooltip
                                PopperProps={{
                                  disablePortal: true,
                                }}
                                onClose={() => setAdminDeleteInfo(false)}
                                placement="top-start"
                                open={openAdminDeleteInfo}
                                disableFocusListener
                                disableHoverListener
                                disableTouchListener
                                title={toolTipAlert}
                              >
                                <Typography variant="subtitle1">
                                  Admin {index + 1}
                                  <IconButton
                                    size="small"
                                    onClick={() => setAdminDeleteInfo(true)}
                                  >
                                    <CloseIcon />
                                  </IconButton>
                                </Typography>
                              </Tooltip>
                            </div>
                          </ClickAwayListener>
                        ) : (
                          <Typography variant="subtitle1">
                            Admin {index + 1}
                            <IconButton
                              size="small"
                              onClick={() => handleRemoveAdmin(index)}
                            >
                              <CloseIcon />
                            </IconButton>
                          </Typography>
                        )}
                        <Grid container spacing={2}>
                          <Grid item xs={6}>
                            <TextField
                              margin="normal"
                              required
                              fullWidth
                              label={strings.displayText.firstName}
                              name="firstName"
                              onChange={(event: any) =>
                                handleAdminInputChange(index, event)
                              }
                              onBlur={(event: any) =>
                                handleAdminInputValidation(index, event)
                              }
                              value={admin.firstName}
                              sx={{
                                '& p': {
                                  color: 'red',
                                },
                                mb: 2,
                              }}
                              helperText={
                                formError?.adminDetails[index]?.firstName
                              }
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <TextField
                              margin="normal"
                              required
                              fullWidth
                              name="lastName"
                              label={strings.displayText.lastName}
                              value={admin.lastName}
                              onChange={(event: any) =>
                                handleAdminInputChange(index, event)
                              }
                              onBlur={(event: any) =>
                                handleAdminInputValidation(index, event)
                              }
                              sx={{
                                '& p': {
                                  color: 'red',
                                },
                                mb: 2,
                              }}
                              helperText={
                                formError?.adminDetails[index]?.lastName
                              }
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <TextField
                              margin="normal"
                              required
                              fullWidth
                              name="email"
                              label={strings.displayText.emailAddress}
                              value={admin.email}
                              onChange={(event: any) =>
                                handleAdminInputChange(index, event)
                              }
                              onBlur={(event: any) =>
                                handleAdminInputValidation(index, event)
                              }
                              sx={{
                                '& p': {
                                  color: 'red',
                                },
                                mb: 2,
                              }}
                              helperText={formError?.adminDetails[index]?.email}
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <MuiPhoneNumber
                              sx={{
                                '& p': {
                                  color: 'red',
                                },
                                my: 2,
                              }}
                              fullWidth
                              label={strings.displayText.phoneNumber}
                              name="phone"
                              defaultCountry={'ie'}
                              variant="outlined"
                              onChange={(value: string | undefined) =>
                                handleAdminInputChange(
                                  index,
                                  undefined,
                                  value,
                                  'phone',
                                )
                              }
                              value={
                                typeof admin.phone === 'string' &&
                                admin.phone.startsWith('++')
                                  ? admin.phone.substring(1)
                                  : admin.phone
                              }
                              helperText={formError?.adminDetails[index]?.phone}
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <FormControl>
                              <InputLabel id="gender">Gender*</InputLabel>
                              <Select
                                label={'Gender'}
                                name={'gender'}
                                required={true}
                                value={admin.gender}
                                onChange={(event: any) =>
                                  handleAdminInputChange(
                                    index,
                                    event,
                                    event.target.value,
                                    'gender',
                                  )
                                }
                                style={{ width: '392px' }}
                              >
                                {genderOptions.map((option) => (
                                  <MenuItem
                                    key={option.value}
                                    value={option.value}
                                  >
                                    {option.label}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </Grid>

                          <Grid item xs={6}>
                            <FormControl>
                              <InputLabel id="maritalStatus">
                                Marital Status*
                              </InputLabel>
                              <Select
                                label={'Marital Status'}
                                name={'marital status'}
                                required={true}
                                value={admin.maritalStatus}
                                onChange={(event: any) =>
                                  handleAdminInputChange(
                                    index,
                                    event,
                                    event.target.value,
                                    'maritalStatus',
                                  )
                                }
                                style={{ width: '392px' }}
                              >
                                {maritalStatusOptions.map((option) => (
                                  <MenuItem
                                    key={option.value}
                                    value={option.value}
                                  >
                                    {option.label}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </Grid>

                          {/* Added employee id, designation and department */}
                          <Grid item xs={3}>
                            <TextField
                              margin="dense"
                              fullWidth
                              label={strings.displayText.employeeID}
                              name={'employeeId'}
                              onChange={(event: any) =>
                                handleAdminInputChange(index, event)
                              }
                              onBlur={(event: any) =>
                                handleAdminInputValidation(index, event)
                              }
                              value={admin.employeeId}
                              sx={{
                                '& p': {
                                  color: 'red',
                                },
                                mb: 2,
                              }}
                              helperText={
                                formError?.adminDetails[index]?.employeeId
                              }
                            />
                          </Grid>
                          <Grid item xs={4}>
                            <TextField
                              margin="dense"
                              fullWidth
                              name="designation"
                              label={strings.displayText.desigination}
                              value={admin.designation}
                              onChange={(event: any) =>
                                handleAdminInputChange(index, event)
                              }
                              onBlur={(event: any) =>
                                handleAdminInputValidation(index, event)
                              }
                              sx={{
                                '& p': {
                                  color: 'red',
                                },
                                mb: 2,
                              }}
                              helperText={
                                formError?.adminDetails[index]?.designation
                              }
                            />
                          </Grid>
                          <Grid item xs={5}>
                            <TextField
                              margin="dense"
                              fullWidth
                              name={'department'}
                              label={strings.displayText.department}
                              value={admin.department}
                              onChange={(event: any) =>
                                handleAdminInputChange(index, event)
                              }
                              onBlur={(event: any) =>
                                handleAdminInputValidation(index, event)
                              }
                              sx={{
                                '& p': {
                                  color: 'red',
                                },
                                mb: 2,
                              }}
                              helperText={
                                formError?.adminDetails[index]?.department
                              }
                            />
                          </Grid>
                          {/* Added employee id, designation and department */}

                          {/* Added Employee & Employer contribution */}
                          <Grid item xs={6}>
                            <TextField
                              margin="dense"
                              required
                              fullWidth
                              name="employeeContribution"
                              label={strings.displayText.employeeContribution}
                              value={admin.employeeContribution}
                              onChange={(event: any) =>
                                handleAdminInputChange(index, event)
                              }
                              onBlur={(event: any) =>
                                handleAdminInputValidation(index, event)
                              }
                              sx={{
                                '& p': {
                                  color: 'red',
                                },
                                mb: 2,
                              }}
                              helperText={
                                formError?.adminDetails[index]
                                  ?.employeeContribution
                              }
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <TextField
                              margin="dense"
                              required
                              fullWidth
                              name="employerContribution"
                              label={strings.displayText.employerContribution}
                              value={admin.employerContribution}
                              onChange={(event: any) =>
                                handleAdminInputChange(index, event)
                              }
                              onBlur={(event: any) =>
                                handleAdminInputValidation(index, event)
                              }
                              sx={{
                                '& p': {
                                  color: 'red',
                                },
                                mb: 2,
                              }}
                              helperText={
                                formError?.adminDetails[index]
                                  ?.employerContribution
                              }
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <TextField
                              margin="dense"
                              required
                              fullWidth
                              name="employeeContributionPercentage"
                              label={
                                strings.displayText.employeeContributionPercent
                              }
                              value={admin.employeeContributionPercentage}
                              onChange={(event: any) =>
                                handleAdminInputChange(index, event)
                              }
                              onBlur={(event: any) =>
                                handleAdminInputValidation(index, event)
                              }
                              sx={{
                                '& p': {
                                  color: 'red',
                                },
                                mb: 2,
                              }}
                              helperText={
                                formError?.adminDetails[index]
                                  ?.employeeContributionPercentage
                              }
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <TextField
                              margin="dense"
                              required
                              fullWidth
                              name="employerContributionPercentage"
                              label={
                                strings.displayText.employerContributionPercent
                              }
                              value={admin.employerContributionPercentage}
                              onChange={(event: any) =>
                                handleAdminInputChange(index, event)
                              }
                              onBlur={(event: any) =>
                                handleAdminInputValidation(index, event)
                              }
                              sx={{
                                '& p': {
                                  color: 'red',
                                },
                                mb: 2,
                              }}
                              helperText={
                                formError?.adminDetails[index]
                                  ?.employerContributionPercentage
                              }
                            />
                          </Grid>
                          {/* Added Employee & Employer contribution */}
                          <Grid
                            item
                            xs={12}
                            style={{ marginTop: '16px' }}
                          ></Grid>
                        </Grid>

                        <Grid container spacing={2}>
                          <Grid item xs={6}>
                            <FormControl>
                              <InputLabel id="economicStatus">
                                Economic status*
                              </InputLabel>
                              <Select
                                labelId="economicStatus"
                                value={admin.economicStatus}
                                onChange={(event: any) =>
                                  handleAdminInputChange(
                                    index,
                                    event,
                                    event.target.value,
                                    'economicStatus',
                                  )
                                }
                                label="Economic status"
                                name={'economicStatus'}
                                style={{ width: '392px' }}
                              >
                                {economicStatusAndOccupation?.categories.map(
                                  (category) => (
                                    <MenuItem
                                      key={category.id}
                                      value={category.id}
                                    >
                                      {category.categoryName}
                                    </MenuItem>
                                  ),
                                )}
                              </Select>
                            </FormControl>
                          </Grid>

                          {admin.economicStatus &&
                            admin.economicStatus !== 12 && (
                              <Grid item xs={6}>
                                <FormControl>
                                  <InputLabel id="economicOccupation">
                                    Economic occupation*
                                  </InputLabel>
                                  <Select
                                    labelId="economicOccupation"
                                    value={admin.economicOccupation}
                                    onChange={(event: any) =>
                                      handleAdminInputChange(
                                        index,
                                        event,
                                        event.target.value,
                                        'economicOccupation',
                                      )
                                    }
                                    label="Economic occupation"
                                    name={'economicOccupation'}
                                    style={{ width: '392px' }}
                                  >
                                    {economicStatusAndOccupation?.categories
                                      .find(
                                        (category) =>
                                          category.id === admin.economicStatus,
                                      )
                                      ?.subCategories.map((subcategory) => (
                                        <MenuItem
                                          key={subcategory.id}
                                          value={subcategory.id}
                                        >
                                          {subcategory.categoryName}
                                        </MenuItem>
                                      ))}
                                  </Select>
                                </FormControl>
                                <Grid item xs={5}>
                                  {' '}
                                </Grid>
                                <Grid
                                  item
                                  xs={12}
                                  style={{ marginTop: '16px' }}
                                ></Grid>
                              </Grid>
                            )}
                          <Grid item xs={6}>
                            <FormControl>
                              <InputLabel id="pepType">
                                {strings.displayText.pepTypeText}
                              </InputLabel>
                              <Select
                                label={strings.displayText.pepTypeText}
                                name={'pepType'}
                                required={true}
                                value={admin.pepType}
                                onChange={(event: any) =>
                                  handleAdminInputChange(
                                    index,
                                    event,
                                    event.target.value,
                                    'pepType',
                                  )
                                }
                                style={{ width: '392px' }}
                              >
                                {pepTypeOptions.map((option) => (
                                  <MenuItem
                                    key={option.value}
                                    value={option.value}
                                  >
                                    {option.label}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </Grid>

                          <Grid
                            item
                            xs={12}
                            style={{ marginTop: '3px' }}
                          ></Grid>
                        </Grid>
                      </Box>
                    </Grid>
                  ),
                )}
                <Grid item xs={12}>
                  <Box
                    sx={{ display: 'flex', justifyContent: 'flex-end' }}
                    py={1}
                  >
                    <Button
                      variant="text"
                      startIcon={<AddIcon />}
                      onClick={handleAddAdmin}
                    >
                      Add another admin
                    </Button>
                  </Box>
                </Grid>
              </>
            )}
          </Grid>
          <Buttons
            // disabled={
            //   formError?.email !== undefined ||
            //   formError?.firstName !== undefined ||
            //   formError?.lastName !== undefined
            // }
            style={{ py: '0.8rem', mt: '1rem' }}
            onClick={handleSaveEmployer}
            fullWidth={true}
            endIcon={loader ? <CircularProgress size={15} /> : null}
            disabled={loader}
          >
            Save
          </Buttons>
        </Box>
      </Box>
    </Fragment>
  );
};

export default EditEmployer;
